import bannerDefaultImage from "../../../Images/cameralogo.png";

const BannerComponent = ({ data }) => {
    return (
        <div className="uploadbannerblmdiv">
            <div className="uploadbannerdivbg">
                <div className="cameralogodivimgabslt" style={{
                    width: '100%',
                    // height: '100%',
                    height: 'auto',
                    maxWidth: '100%',
                    minWidth: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    padding: '0px'


                }}>
                    {data?.businesBanner ? (
                        <div className="cameralogodivimg" style={{
                            width: '100%',
                            // height: '100%',
                            height: 'auto',
                            maxWidth: '100%',
                            minWidth: '100%',
                        }}>
                            <img
                                style={{
                                    width: "100%",
                                    // height: "100%",
                                    height:"auto",
                                    objectFit: "cover",
                                    borderRadius: "10px",
                                }}
                                src={data?.businesBanner}
                                alt="..."
                            />
                        </div>
                    ) : (
                        <>
                            <div>


                                <div className="cameralogodivimg">
                                    <img src={bannerDefaultImage} alt="Business Banner Default Image" />
                                </div>
                                {/* <p className="uplsdttxttppshji">Upload Banner</p>
                                <p className="pixelsttxttppio">
                                    (Pixel Size : 942 x 283 PNG/JPEG )
                                </p> */}
                            </div>
                        </>
                    )}
                </div>
            </div>
        </div>
    );
};
export default BannerComponent;